import administrationDashboardMorePublished from "~/store/graphql/queries/administrationDashboardMorePublished.graphql";

import runGraphQLQuery from "~/store/manage/utilities/runGraphQLQuery";

const loadAdminstrationMorePublished = async function (
  { commit, state },
  { params = {}, req, res }
) {
  commit("START_LOADING");

  params.searchPhrase = state.currentAdministrator.publishedItemsSearchPhrase;
  const data = await runGraphQLQuery(
    administrationDashboardMorePublished,
    params,
    this.$axios,
    req,
    res
  );

  const featureToggles = {
    administrationDashboardSiteModerators: this.$unleash.isEnabled(
      "administrationDashboardSiteModerators"
    ),
    showModerationNotes: this.$unleash.isEnabled("showModerationNotes"),
    administrationDashboardAssignCurators: this.$unleash.isEnabled(
      "administrationDashboardAssignCurators"
    ),
  };

  commit("SET_ADMINISTRATION_MORE_PUBLISHED", {
    payload: data,
    featureToggles,
  });
  commit("END_LOADING");

  return Promise.resolve(data);
};

export default loadAdminstrationMorePublished;
